import { FormField } from "./Form.interface"
import Media from "./Media.interface"

export default interface Chatbot {
    id: number
    object?: string
    name: string
    schema?: ChatbotSchemaEntry[]
    styles?: ChatbotStyles
    response_message?: string
    response_media?: Media
    response_enabled?: boolean
    group_id?: number
    key?: string
    allowed_domains?: string[]
    created_at?: Date | string
    updated_at?: Date | string
    deleted_at?: Date | string
}

//  CHATBOT.SCHEMA
export interface ChatbotSchemaEntry {
    content: string | ChatbotSchemaContent
    contentType: ChatbotSchemaContentType
    reciever?: boolean
}
//  CHATBOT.SCHEMA.CONTENT
export interface ChatbotSchemaContent {
    name: string
    inputs: FormField[]
    successMessage: string
    submitMessage?: string
    complianceMessage?: string
    privacyPolicyLink?: string
    termsOfServiceLink?: string
}

export enum ChatbotSchemaContentType {
    form = 'form',
    text = 'text'
}

//  CHATBOT.STYLES
export interface ChatbotStyles {
    agent: ChatbotStylesAgent
    colors: ChatbotStylesColors
    header: ChatbotStylesHeader
    icon: ChatbotStylesIcon
}
//  CHATBOT.STYLES.AGENT
export interface ChatbotStylesAgent {
    image: string
    message: string
    disabled: boolean
}
//  CHATBOT.STYLES.COLORS
export interface ChatbotStylesColors {
    primary: string
    secondary: string
    background: string
    bubbles: ChatbotStylesColorsBubbles
}
//  CHATBOT.STYLES.COLORS.BUBBLES
export interface ChatbotStylesColorsBubbles {
    reciever: string
    sender: string
}
//  CHATBOT.STYLES.HEADER
export interface ChatbotStylesHeader {
    title: string
    subtitle: string
}
//  CHATBOT.STYLES.ICON
export interface ChatbotStylesIcon {
    image: string
}
